import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const Paragraph = (props: SvgIconT.Props) => (
  <SvgIcon width={24} height={24} {...props} viewBox="0 0 24 24">
    <path
      fill-rule="nonzero"
      d="M9 4H1v1h8V4Zm0 3H1v1h8V7Zm-8 3h8v1H1v-1Zm8 3H1v1h8v-1Zm-8 3h12v1H1v-1Zm12 3H1v1h12v-1Zm8-15h2v1h-2v15h-1V5h-3v15h-1v-6a5 5 0 0 1 0-10h5Zm-9 5c0 2.206 1.794 4 4 4V5c-2.206 0-4 1.794-4 4Z"
    />
  </SvgIcon>
);

export default Paragraph;
